import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ral-side-logo-header',
  templateUrl: './side-logo-header.component.html',
  styleUrls: ['./side-logo-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideLogoHeaderComponent {
  @Input() title = 'Admin';
  // By default takes faviicon
  @Input() logo = '/assets/favicon/web-app-manifest-512x512.png';

  @Output() toggle: EventEmitter<void> = new EventEmitter();
}
